import { defineMessages } from 'react-intl'

const scope = `procurify.expense.RequestableSecondaryCategorySelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select {singularSecondaryOrgCategoryLabel}',
  },
})
